import { useState } from "react"
import { ConsumersListType } from "@/types"
import { createFileRoute } from "@tanstack/react-router"
import { Download } from "lucide-react"

import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { announcementsColumns } from "@/components/table/columns/announcements-columns"

export const Route = createFileRoute("/_home/system-config/announcement/")({
  component: AnnouncementPage,
})

function AnnouncementPage() {
  //to be replaced by API
  const mockData: ConsumersListType[] = [
    {
      consumer_id: 1,
      name: "John Doe",
      email: "johndoe@example.com",
      contact_num: "123-456-7890",
      address: "123 Main St, City, Country",
      connection_status_name: "Active",
      connection_type_name: "Fiber",
    },
    {
      consumer_id: 2,
      name: "Jane Smith",
      email: "janesmith@example.com",
      contact_num: "987-654-3210",
      address: "456 Elm St, City, Country",
      connection_status_name: "Disconnection",
      connection_type_name: "DSL",
    },
    {
      consumer_id: 3,
      name: "Bryan Lim",
      email: "janesmith@example.com",
      contact_num: "987-654-3210",
      address: "456 Elm St, City, Country",
      connection_status_name: "Disconnection",
      connection_type_name: "DSL",
    },
    {
      consumer_id: 4,
      name: "Stephen Larcia",
      email: "janesmith@example.com",
      contact_num: "987-654-3210",
      address: "456 Elm St, City, Country",
      connection_status_name: "Disconnection",
      connection_type_name: "DSL",
    },
  ]

  const [data, setData] = useState(mockData)
  const [defaultPage, setDefaultPage] = useState<number>(1)
  const [page, setPage] = useState<number>(10)
  const [search, setSearch] = useState<string>("")

  const [nextPageUrl] = useState<string | null>(null)
  const [prevPageUrl] = useState<string | null>(null)

  return (
    <div className="space-y-4 p-4">
      <Header>Announcement</Header>

      {/* <DataTable
        columns={announcementsColumns}
        data={data ?? []}
        search={{
          field: "name",
          label: "Announcement",
          value: search,
          onChange: setSearch,
        }}
        defaultPage={defaultPage}
        setDefaultPage={setDefaultPage}
        nextPageUrl={nextPageUrl}
        prevPageUrl={prevPageUrl}
        page={page}
        setPage={setPage}
        showSelectedRows
      >
        <div className="flex w-full justify-end">
          <Button onClick={() => print()}>
            <Download /> Print Report
          </Button>
        </div>
      </DataTable> */}
    </div>
  )
}
